module.exports = __webpack_public_path__ + "static/media/Icon-Live.4c7c7284.svg";